<ng-container *ngIf="!allowPercent">
  {{ currency ?? (prodDefaults$ | async)?.currency }}
</ng-container>

<ng-container *ngIf="allowPercent">
  <button type="button" (click)="toggleDimension()" class="suffix-button">
    <span *ngIf="(dimension$ | async)===1"><mat-icon class="inline-button">check</mat-icon></span>
    %
  </button>
  <button type="button" (click)="toggleDimension()" class="suffix-button">
    <span *ngIf="(dimension$ | async)!==1"><mat-icon class="inline-button">check</mat-icon></span>
    {{ currency ?? (prodDefaults$ | async)?.currency }}
  </button>
</ng-container>